import { useEffect, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import moment from "moment";

import SortIcon from "src/components/ui-icons/table/SortIcon";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";

const DownloadEmployesTableSingle = (props: any) => {
  const { data, setExportData, cardVersion } = props;
  const [sortData, setSortData] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const [tableHeaderContent, setTableHeaderContent] = useState<any>({
    User: {
      title: "Сотрудник",
      sort: true,
      width: "25%",
      sortDirection: "default",
      sortType: "string",
    },
    Manager: {
      title: "Непосредственный руководитель",
      sort: true,
      width: "25%",
      sortDirection: "default",
      sortType: "date",
    },
    Created: {
      title: "Дата скачивания документа",
      sort: true,
      width: "25%",
      sortDirection: "default",
      sortType: "date",
    },
    Ver: {
      title: "Версия документа",
      sort: false,
      width: "15%",
      sortDirection: "default",
      sortType: "number",
    },
    ActiveType: {
      title: "Тип",
      sort: true,
      width: "10%",
      sortDirection: "default",
      sortType: "string",
    },
  });

  const sortDataHandle = (
    sortField: string,
    sortDirection: string,
    sortType: string
  ) => {
    const tempTableHeaderContent = { ...tableHeaderContent };
    const tempData = [
      ...data.map((item: any) => {
        return {
          ...item,
          ...{
            User:
              (users[item.Author.get_email().toLowerCase()] &&
                users[item.Author.get_email().toLowerCase()]["displayName"]) ||
              "-",
            Manager:
              (users[item.Author.get_email().toLowerCase()] &&
                users[item.Author.get_email().toLowerCase()]["manager"] &&
                users[
                users[item.Author.get_email().toLowerCase()]["manager"]
                ] &&
                users[users[item.Author.get_email().toLowerCase()]["manager"]][
                "displayName"
                ]) ||
              "-",
            Ver: cardVersion,
          },
        };
      }),
    ];
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    if (sortDirection === "default") {
      tempTableHeaderContent[sortField]["sortDirection"] = "desc";
    }
    if (sortDirection === "desc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "asc";
    }
    if (sortDirection === "asc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "default";
      setSortData([...data]);
    }
    if (sortType === "number") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort(
          (a: any, b: any) =>
            parseFloat(a[sortField]) - parseFloat(b[sortField])
        );
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort(
          (a: any, b: any) =>
            parseFloat(b[sortField]) - parseFloat(a[sortField])
        );
      }
    }
    if (sortType === "string") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort((a: any, b: any) => {
          return a[sortField].localeCompare(b[sortField]);
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort((a: any, b: any) => {
          return b[sortField].localeCompare(a[sortField]);
        });
      }
    }
    if (sortType === "date") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateA.getTime() - dateB.getTime();
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateB.getTime() - dateA.getTime();
        });
      }
    }
    setTableHeaderContent({ ...tempTableHeaderContent });
    setSortData([...tempData]);
  };

  useEffect(() => {
    setSortData([...data]);
    const tempTableHeaderContent = { ...tableHeaderContent };
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    setTableHeaderContent({ ...tempTableHeaderContent });
  }, [data]);

  useEffect(() => {
    if (sortData.length > 0) {
      let exportColumns: any = [];
      Object.keys(tableHeaderContent).map((key: any) => {
        exportColumns = [
          ...exportColumns,
          {
            header: tableHeaderContent[key]["title"],
            key: key,
            width: 50,
          },
        ];
      });
      let exportData: any = [];
      sortData.forEach((item: any) => {
        exportData = [
          ...exportData,
          {
            User:
              (users[item.Author.get_email().toLowerCase()] &&
                users[item.Author.get_email().toLowerCase()]["displayName"]) ||
              "-",
            Manager:
              (users[item.Author.get_email().toLowerCase()] &&
                users[item.Author.get_email().toLowerCase()]["manager"] &&
                users[
                users[item.Author.get_email().toLowerCase()]["manager"]
                ] &&
                users[users[item.Author.get_email().toLowerCase()]["manager"]][
                "displayName"
                ]) ||
              "-",
            Created: moment(item.Created).format("DD.MM.YYYY"),
            Ver: cardVersion,
            ActiveType: item.ActiveType,
          },
        ];
      });
      setExportData({ columns: [...exportColumns], data: [...exportData] });
    }
  }, [sortData, users]);

  return (
    <FlexCol className="w-full">
      <FlexCol className="relative">
        <FlexCol
          id="owd_calendar_wrapper"
          className="relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-340px)] min-h-[60px]"
        >
          <FlexRow className="pb-5 sticky-custom max-h-[65px] min-w-[1200px] bg-white pt-5 px-10 gap-5 z-10">
            {Object.keys(tableHeaderContent).map((fieldKey) => {
              const key: string = fieldKey;
              return (
                <TableHeaderColumn
                  key={fieldKey}
                  sortField={fieldKey}
                  tableHeaderContent={tableHeaderContent[key]}
                  sortDataHandle={sortDataHandle}
                />
              );
            })}
          </FlexRow>
          <FlexCol className="divide-y grow min-w-[1200px] px-10">
            {sortData.map((item: any) => (
              <FlexRow className="py-4 -mx-2 px-2 gap-5 w-full" key={item.ID}>
                <FlexCol
                  style={{ width: "25%" }}
                  className="break-words text-[#637381]"
                >
                  {(users[item.Author.get_email().toLowerCase()] &&
                    users[item.Author.get_email().toLowerCase()][
                    "displayName"
                    ]) ||
                    "-"}
                </FlexCol>
                <FlexCol
                  style={{ width: "25%" }}
                  className="break-words text-[#637381]"
                >
                  {(users[item.Author.get_email().toLowerCase()] &&
                    users[item.Author.get_email().toLowerCase()]["manager"] &&
                    users[
                    users[item.Author.get_email().toLowerCase()]["manager"]
                    ] &&
                    users[
                    users[item.Author.get_email().toLowerCase()]["manager"]
                    ]["displayName"]) ||
                    "-"}
                </FlexCol>
                <FlexCol
                  style={{ width: "25%" }}
                  className="break-words text-[#637381]"
                >
                  {moment(item.Created).format("DD.MM.YYYY")}
                </FlexCol>
                <FlexCol
                  style={{ width: "15%" }}
                  className="break-words text-[#637381]"
                >
                  <span className="block text-sm font-normal not-italic text-[#637381]">
                    {cardVersion}
                  </span>
                </FlexCol>
                <FlexCol
                  style={{ width: "10%" }}
                  className="break-words text-[#637381]"
                >
                  <span className="block text-sm font-normal not-italic text-[#637381]">
                    {item.ActiveType}
                  </span>
                </FlexCol>
              </FlexRow>
            ))}
          </FlexCol>
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};

export default DownloadEmployesTableSingle;

export function TableHeaderColumn({
  tableHeaderContent,
  sortDataHandle,
  sortField,
}: any) {
  return (
    <FlexCol
      className="select-none"
      style={{ width: tableHeaderContent.width }}
    >
      <FlexRow className="gap-x-2 w-full">
        {tableHeaderContent.icon && (
          <FlexCol>{tableHeaderContent.icon}</FlexCol>
        )}
        <FlexCol className="font-medium whitespace-pre-line">
          {tableHeaderContent.title}
        </FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol
            className="w-auto cursor-pointer"
            onClick={() =>
              sortDataHandle(
                sortField,
                tableHeaderContent.sortDirection,
                tableHeaderContent.sortType
              )
            }
          >
            <SortIcon sortDirection={tableHeaderContent.sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}
